import * as PIXI from 'pixi.js'

//TouchID
var _touchID: number = -1

//Global Touch Position
var _global: PIXI.Point = new PIXI.Point()

const TouchUtil = {
  touchID: _touchID,
  global: _global,
}
export default TouchUtil
